import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

export const eventApi = createApi({
  reducerPath: 'eventApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getEvents: builder.query<any, { entityId?: string }>({
      query: ({ entityId }) => ({
        url: entityId ? `api/v1/entities/${entityId}/events` : 'api/v1/events',
        method: 'GET',
        params: { per_page: 100 },
      }),
    }),
  }),
});

export const { useGetEventsQuery } = eventApi;
